import {defineStore} from 'pinia';
import api from '@/api/api';
import {useLogsStore} from "@/stores/logs";
import AuthService from "@/services/auth.service";
import ErrorUtils from "@/utils/error.utils";

export const useAuthStore = defineStore('auth', {
    state: () => {
        return {
            access_token: null,
            refresh_token: null,
            refreshTokenTimeout: null,
            menu: []
        }
    },
    actions: {
        async login(loginInfos) {
            try {
                const responseLogin = await api().post('/auth/login', loginInfos);
                if (responseLogin) {
                    const {data} = responseLogin;

                    this.access_token = data.access_token;
                    this.refresh_token = data.refresh_token;
                    this.menu = [];

                    this.startCounterRefreshToken();
                    return {success: true, message: null}
                }

                return {success: false, message: "Usuário ou senha inválidos."};
            } catch (error) {
                return {success: false, message: ErrorUtils.toMessage(error, true)};
            }
        },

        async refreshToken() {
            try {
                const responseRefresh = await api().post('/auth/refresh', {refresh_token: this.refresh_token})

                if (responseRefresh) {
                    const {data} = responseRefresh;

                    this.access_token = data.access_token;
                    this.refresh_token = data.refresh_token;
                    this.startCounterRefreshToken();
                    return;
                }
            } catch (error) {
                this.access_token = null;
                this.refresh_token = null;

                window.postMessage("login-expirado");
            }
        },

        startCounterRefreshToken() {
            const jwtBase64 = this.access_token.split('.')[1];
            const jwtToken = JSON.parse(atob(jwtBase64));

            const expires = new Date(jwtToken.exp * 1000);
            const timeout = expires.getTime() - Date.now() - (60 * 1000);

            this.refreshTokenTimeout = setTimeout(this.refreshToken, timeout);
        },

        resetCounterRefresh() {
            if (this.access_token) {
                this.stopCounterRefreshToken();
                this.startCounterRefreshToken();
            }
        },

        stopCounterRefreshToken() {
            clearTimeout(this.refreshTokenTimeout);
            this.refreshTokenTimeout = null;
        },

        async logout() {
            try {
                if (this.refresh_token) {
                    await api().post('/auth/logout', {refresh_token: this.refresh_token});
                }

                this.access_token = null;
                this.refresh_token = null;
                this.menu = [];
                this.stopCounterRefreshToken();

                useLogsStore().reset()

                return {success: true}
            } catch (error) {
                return {success: false}
            }
        },

        getLoggedInUsernameAndName() {
            if (!this.access_token) {
                return null;
            }

            try {
                const jwtBase64 = this.access_token.split('.')[1];
                const jwtToken = JSON.parse(decodeURIComponent(atob(jwtBase64)));

                return {
                    username: jwtToken?.sub || null,
                    name: jwtToken?.name || null,
                    profile: jwtToken?.profile || null
                };
            } catch (error) {
                console.error("Erro ao decodificar o JWT:", error);
                return null;
            }
        },

        async getMenu() {
            if (this.menu.length === 0) {
                try {
                    const response = await AuthService.getMenu();
                    this.menu = response.data;
                } catch (error) {
                    console.error("Erro ao buscar menu:", error);
                }
            }
            return this.menu;
        }
    },
    persist:
        [
            {pick: ['access_token', 'refresh_token'], storage: sessionStorage},
            {pick: ['refreshTokenTimeout', 'menu'], storage: localStorage},
        ],
})
